module.exports = __webpack_public_path__ + "static/media/record.48e03290.svg";